import has from 'lodash/has';
import mapValues from 'lodash/mapValues';
// import {LOAD} from 'redux-storage';
import {getSyncStatus} from '../../_libs/redux-observable-list';
import {actionIsSelected} from '../utils';

/**
 *
 * @param {TodoMessageReduxList} reduxList
 */
export function buildReducers(reduxList) {
  const getListId = reduxList.reducers.getListId;
  const updatesReducer = reduxList.reducers.updatesReducer;
  const reducer = reduxList.reducers.reducer;

  /**
   * @param {ReduxObservableListState} state
   * @param {ReduxAction} action
   * @return {ReduxObservableListState}
   */
  return function (state = reduxList.reducers.initialState, action) {
    switch (action.type) {
      case reduxList.actions.selectAction.TYPE:
        return selectActionReducer(state, action);

      case reduxList.actions.updateI18n.TYPE:
        return updateI18nReducer(state, action);

      // TODO: use if we enable caching
      // case LOAD:
      //   return loadReducer(state, action);

      default:
        return reducer(state, action);
    }
  };

  /**
   * @param {ReduxObservableListState} state
   * @param {ReduxAction<SelectActionPayload>} action
   * @return {ReduxObservableListState}
   */
  function selectActionReducer(state, action) {
    const itemId = getListId(action.payload.id, action.payload.requestId, state.list);
    const existingItem = state.list[itemId];
    if (existingItem && !actionIsSelected(existingItem)) {
      // change the item state to selected
      // change the message to display to the selected message for that action
      const syncStatus = getSyncStatus(state.updates[itemId]);
      const nextItem = {
        ...existingItem,
        selectedAction: action.payload.actionId,
        syncStatus,
      };

      if (existingItem.actions[action.payload.actionId].type === 'ok') {
        nextItem.isDeleting = true;
      } else {
        nextItem.message = existingItem.actions[action.payload.actionId].selectedMessage;
      }

      return {
        ...state,
        list: {
          ...state.list,
          [itemId]: nextItem,
        },
        updates: updatesReducer(state.updates, itemId, syncStatus),
      };

    } else {
      console.warn(`selectActionReducer missing item`);
      return state;
    }
  }

  /**
   * Get the updated message data from the epic but keep selectedAction and syncStatus changes made.
   * Since the epic is modifying the list, we must consolidate the changes carefully to avoid race condition problems.
   * @param {ReduxObservableListState} state
   * @param {ReduxAction} action
   * @return {ReduxObservableListState}
   */
  function updateI18nReducer(state, action) {
    const i18nList = action.payload.list;
    const nextList = mapValues(state.list, (item, id) => {
      if (i18nList[id]) {
        if (has(item, 'selectedAction') || has(item, 'syncStatus')) {
          return {
            ...i18nList[id],
            selectedAction: item.selectedAction,
            syncStatus: item.syncStatus,
          };
        } else {
          return i18nList[id];
        }
      } else {
        return item;
      }
    });

    return {
      ...state,
      list: nextList,
    };
  }
}



// WEBPACK FOOTER //
// ./src/js/todo-messages/redux/todoMessageReducers.js